// All comments in English.
import { useQuery } from "@tanstack/react-query";
import { getProductTopHolders } from "../api/risk";

export function useProductTopHolders(
  product: string,
  pageSize = 10,
  sort = "-active_seats"
) {
  return useQuery({
    queryKey: ["productTopHolders", product, pageSize, sort],
    queryFn: () => getProductTopHolders({ product, page_size: pageSize, sort }),
    enabled: !!product,
  });
}
